import { render, staticRenderFns } from "./BudgetDashboardChart.vue?vue&type=template&id=4597398c&scoped=true&"
import script from "./BudgetDashboardChart.vue?vue&type=script&lang=js&"
export * from "./BudgetDashboardChart.vue?vue&type=script&lang=js&"
import style0 from "./BudgetDashboardChart.vue?vue&type=style&index=0&id=4597398c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4597398c",
  null
  
)

export default component.exports